import {createAction, createReducer} from '@reduxjs/toolkit';
import {filter, forEach, get} from 'lodash-es';
import {orderConfirmationService} from "../../../services/equity/orderForm/orderConfirmationService";

const Actions = {
	setOrderFeed: 'setOrderFeed',
	setOrderFeedThrottled: 'setOrderFeedThrottled',
	resetOrderFeed: 'resetOrderFeed',
	startLister: 'startLister',
	stopLister: 'stopLister',
	setCurrentOrderId: 'setCurrentOrderId',
};

// actions
export const setOrderFeed = createAction(Actions.setOrderFeed);
export const setOrderFeedThrottled = createAction(Actions.setOrderFeedThrottled);
export const resetOrderFeed = createAction(Actions.resetOrderFeed);
export const startLister = createAction(Actions.startLister);
export const stopLister = createAction(Actions.stopLister);
export const setCurrentOrderId = createAction(Actions.setCurrentOrderId);

// selector

export const getOrderFeed = (orderId, flow) => (state) => {
	const feeds =  get(state, `tradeSocket.${orderId}`, [{ status: orderConfirmationService.STATUSES_MAP.submitted, rawStatus: 1 }]);
	switch (flow) {
		case orderConfirmationService.FLOWS.cancel:
			return filter(feeds, (f) => orderConfirmationService.CANCEL_ORDER_ALLOWED_STATUSES.includes(f.status));
		default:
			return feeds;
	}
};

export const getCurrentOrderId = (state) => {
	return get(state, 'tradeSocket.currentOrderId', '');
};

// initial state
const initialState = {
	currentOrderId: '',
};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setOrderFeed, (state, action) => {
		const message = action.payload;
		const orderId = message.UniqueCode;
		if (orderId) {
			const feeds = state[orderId] || [];
			state[orderId] = [
				...feeds,
				{
					status: orderConfirmationService.getOrderStatusFromFeed(message),
					rawStatus: message.OrderStatus || message.Status,
					tradedQTY: message.TradedQTY,
					pendingQty: message.PendingQty,
					orderPrice: message.OrderPrice,
				},
			];
		}
	});
	builder.addCase(resetOrderFeed, (state, action) => {
		forEach(state, (_, key) => {
			delete state[key];
		});
	});
	builder.addCase(setCurrentOrderId, (state, action) => {
		state.currentOrderId = action.payload;
	});
});
